var sha1 = require('sha1');
var Fingerprint2 = require('fingerprintjs2');
var { error } = require('./error')
var moment = require('moment'); // require

var User = function({
    vm : vm,
    api
}){

    var self = this

    var fingerprint = '';

    var state = {

        value : -1,

        set _value(v){
            this.value = v;
           
            vm.$store.commit('auth', this.value)
           
        },

        get _value(){
            return this.value
        },

        is : function(){

            switch (this.value) {
                case -1:
                    
                    pwdhash.init()
                    login.init()
                
                    if (login.value && pwdhash.value){
    
                        return signin({
                            cpwdhash : pwdhash.value,
                            clogin : login.value
                        })
    
                    }
                    else{
                        this._value = 0;
    
                        return Promise.resolve(this.value)
                    }
    
                    break;
    
                case 0:
                case 1:
                    return Promise.resolve(this.value)
    
                case 2:
                    console.log( 'ch' );
                    break;
    
                default:
                    this._value = -1;
                    
                    return this.is()
            }
        }

    };

   
    var pwdhash = {
        value : "",
        get _value(){
            return this.value
        },
        set _value(v){
            if(v){
                this.value = v;

            }
            else{
                localStorage.removeItem(prefix + '-pwdhash');
            }
        },

        init : function(){
            
        }
    };

    var login = {
        value : "",
        get _value(){
            return this.value
        },

        set _value(v){
            if(v){

                this.value = v;
            }
            else{
                localStorage.removeItem(prefix + '-login');
            }
        },

        init : function(){
           
        }
    };

    var ip = {
        value : "",
        get _value(){
            return this.value
        },
        set _value(v){
            if(v){
                
                this.value = v;

            }
            else{
                this.value = ''
            }
        }
    };

    var salt = process.env.VUE_APP_RX_SALT;
    var prefix = process.env.VUE_APP_RX_APP_PREFIX + 'service';
    var axios = null;

    function crypt (password){
        return sha1(password + salt).toUpperCase()
    }

    async function extendA(data){

        data.fingerprint = fingerprint

        if(state._value != 1){

            return Promise.resolve(data)

        }
        else{

	
            if (login._value)
                data.login = login._value

            if (pwdhash._value)
                data.pwdhash = pwdhash._value

            if (ip._value)
                data.IP = ip._value

        

            return Promise.resolve(data)
        }
    }

    function extendU(data){

        if(state._value == 1){

            if(data.IP)
			{
                ip._value = data.IP
            }
            
        }
        
    }

    function setaxios(_axios){
        axios = _axios
    }

    function prepare(){
        
    }

    function setFingerPrint(){

        if(typeof window != 'undefined'){

            if(!fingerprint){

                return Fingerprint2.getPromise({}).then(function (components) {
    
                    var values = components.map(function (component) { return component.value })
                        fingerprint = Fingerprint2.x64hash128(values.join(''), 31)
        
                    return fingerprint
                })
    
            }
            
        }

        return Promise.resolve(fingerprint)

    }

    function signout(){

        if (self.ws){
            self.ws.signout()
        }

        state._value = 0
        pwdhash._value = ''
        login._value = ''

        vm.$store.commit('userinfo', null)

        
    }

    async function signup({
        password : _password,
        login : _login,
        data: _data
    }){

        var en = false
        var data = {..._data}

        if (_password && _login){

            data.pwdhash = crypt(_password)
            data.login = _login

            en = true;
        }

        if (en){

            return api.account.signup(data).then( data => {

                state._value = 1
                pwdhash._value = data.pwdhash
                login._value = data.login

                return state._value

            })

            .then(() => {

                return state._value

            }).catch(e => {

                console.log(e)

                state._value = 0

                return Promise.reject(e);

            })

        }

        console.log(error)

        state._value = 0

        return Promise.reject(error(511))

    }

    async function signin({
        cpassword : cpassword,
        clogin : clogin,
        cpwdhash : cpwdhash
    }){

        var en = false

        var data = {}

        if ((cpassword || cpwdhash) && clogin){
            data.pwdhash = cpwdhash || crypt(cpassword)
            data.login = clogin
            en = true;
        }


        if (en){

            state._value = 2


            return api.account.signin(data).then( result => {

                var info = vm.$f.deep(result, 'data.0')   

                if (info){

                    state._value = 1
                    pwdhash._value = data.pwdhash
                    login._value = data.login

                    vm.$store.commit('userinfo', info)

                }

                return state._value

            })

            .then(() => {
                return state._value

            }).catch(e => {

                console.log(e)

                state._value = 0

                return e
            })

        }

        state._value = 0

        return Promise.reject(error(511))

    }

    var confirmDate = {
        phone : null,
        email : null
    }

    var edit = {

        info : function(obj){

            return api.account.info.edit({
                info : JSON.stringify(obj)
            }).then(result => {

                vm.$store.commit('userinfo_change', obj)

                return Promise.resolve()

            })
        }

    }

    var upload = {
        userpicture : function(image){
            return api.account.upload.userpicture({
                image : image
            }).then(result => {

                console.log(result)

                vm.$store.commit('userinfo_change', {
                    userpicture : result.data.fileid
                })

                return Promise.resolve()

            })
        }
    }

    var verification = {
        requestConfirm : {

            phone : function(phone){
                var now = moment()
    
                if(!confirmDate.phone || confirmDate.phone > moment().add(45, 's')){
    
                    return api.account.requestConfirm.phone({phone : phone}).then( result => {
    
                        confirmDate.phone = now
    
                        return Promise.resolve(confirmDate.phone)
        
                    })
                
                }
    
                else{
                    return Promise.resolve(confirmDate.phone)
                }
            },

            email : function(email){
                var now = moment()
    
                if(!confirmDate.email || confirmDate.email > moment().add(45, 's')){
    
                    return api.account.requestConfirm.email({email : email}).then( result => {
    
                        confirmDate.email = now
    
                        return Promise.resolve(confirmDate.email)
        
                    })
                
                }
    
                else{
                    return Promise.resolve(confirmDate.email)
                }
            }
        },
        confirm : {
            phone : function(phone, code){
    
                return api.account.confirm.phone({phone : phone, code : code}).then( result => {


                    vm.$store.commit('userinfo_change', 1, 'phoneconfirmed')

                    return Promise.resolve(result)
    
                })
               
            },

            email : function(hash){
    
                return api.account.confirm.email({hash : hash}).then( result => {


                    vm.$store.commit('userinfo_change', 1, 'emailconfirmed')

                    return Promise.resolve(result)
    
                })
               
            }
        }
    }

    self.changePassword = function(pwd){
        pwd = crypt(pwd)

        return api.account.password.change(pwd).then(result => {

            if (result.data.changed)

                pwdhash._value = pwd

            return Promise.resolve(result.data)

        })
    }

    self.checkPassword = function(pwd){
        return crypt(pwd) == pwdhash._value
    }

    self.connectToDoc = (code) => {
        return api.patient.connectWithDoc(code);
    }

    self.upload = upload
    self.state = state
    self.prepare = prepare
    self.setaxios = setaxios
    self.extendA = extendA
    self.extendU = extendU
    self.setFingerPrint = setFingerPrint
    self.signin = signin
    self.signup = signup
    self.signout = signout
    self.verification = verification
    self.edit = edit
    self.crypt = crypt

    return self

}



export default User